// ** React Imports
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';

// ** Redux Imports
import { Provider } from 'react-redux';
import { store } from './redux/storeConfig/store';

// ** Toast & ThemeColors Context
import ability from './configs/acl/ability';
import { ToastContainer } from 'react-toastify';
import { AbilityContext } from './utility/context/Can';
import { ThemeContext } from './utility/context/ThemeColors';

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner';

// ** Ripple Button
import './@core/components/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss';

// ** Core styles
import './@core/assets/fonts/fonts.css';
import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style.scss';

// ** Service Worker
import * as serviceWorker from './serviceWorker';

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

import NiceModal from '@ebay/nice-modal-react';
import { CapturaBiometrico } from './views/FichasActivas/NuevaFicha/Modals/CapturaBiometrico';
import { BiometricProvider } from './utility/context/Biometric';

ReactDOM.render(
	<Provider store={store}>
		<ThemeContext>
			<BiometricProvider>
				<AbilityContext.Provider value={ability}>
					<NiceModal.Provider>
						<Suspense fallback={<Spinner />}>
							<LazyApp />
							<ToastContainer
								newestOnTop={false}
								position="bottom-right"
								autoClose={false}
								closeOnClick={false}
								rtl={false}
								pauseOnFocusLoss={false}
								draggable={false}
								theme="colored"
							/>
						</Suspense>
					</NiceModal.Provider>
				</AbilityContext.Provider>
			</BiometricProvider>
		</ThemeContext>
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
